<template>
  <el-form
    class="simple-form"
    ref="form"
    :label-position="formattedLabelPosition"
    :label-width="formattedLabelWidth"
    :style="formattedFormStyle"
    :hide-required-asterisk="hideRequiredAsterisk"
    :model="model"
    :inline-message="messageInline"
    :rules="formRules"
  >
    <template v-for="(item, key) in formLines">
      <slot :name="item.lineSlot" :line="{ name: key, line: item, componentSelf }">
        <el-form-item
          v-if="!item.hidden"
          :key="key"
          :class="item.class"
          :label="item.label"
          :prop="key"
          :validateStatus="formErrors[key] && 'error'"
          :error="formErrors[key]"
        >
          <template v-if="item.labelSlot" #label>
            <slot :name="item.labelSlot" :line="{ name: key, line: item }"></slot>
          </template>
          <template v-if="item.type === 'submitBtn'">
            <el-button class="submit-btn" @click="onSubmit">{{ item.btnText }}</el-button>
          </template>
          <template v-else-if="item.type === 'password'">
            <el-input v-model="model[key]" class="password-input" show-password :placeholder="item.placeholder"/>
          </template>
          <template v-else>
            <slot :name="item.contentSlot" :line="{ name: key, line: item }">
              <el-input v-model="model[key]" :name="key" :placeholder="item.placeholder"/>
            </slot>
          </template>
        </el-form-item>
      </slot>
    </template>
  </el-form>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    labelPosition: {
      default: 'right'
    },
    labelWidth: {
      default: '33.33%'
    },
    formStyle: {
      default: () => { return { width: '80%', margin: 'auto' } }
    },
    model: {
      required: true
    },
    formLines: {
      required: true
    },
    formErrors: {
      default: () => { return {} }
    },
    hideRequiredAsterisk: {
      default: false
    },
    messageInline: {
      default: false
    }
  },
  data () {
    return {
      componentSelf: this
    }
  },
  computed: {
    formattedLabelPosition () {
      if (this.labelPosition) {
        return this.labelPosition
      } else {
        return 'right'
      }
    },
    formattedLabelWidth () {
      if (this.labelWidth) {
        return this.labelWidth
      } else {
        return '33.33%'
      }
    },
    formattedFormStyle () {
      if (this.formStyle) {
        return this.formStyle
      } else {
        return { margin: '0 10%' }
      }
    },
    formRules () {
      const rules = {}
      _.forEach(this.formLines, (item, key) => {
        if (item.rules && !item.hidden) {
          rules[key] = item.rules
        }
      })
      return rules
    },
    form () {
      const form = {
        ...this.$refs.form,
        validate: (callBack) => {
          if (!callBack) {
            return this.$refs.form.validate()
          } else {
            this.$refs.form.validate((isSuccess, failObject) => {
              if (!isSuccess) {
                this.$nextTick(() => {
                  document.querySelector('.el-form-item.is-error').scrollIntoView({ block: 'center', behavior: 'smooth' })
                })
              }
              callBack(isSuccess, failObject)
            })
          }
        }
      }
      return form
    }
  },
  created () {

  },
  methods: {
    validateField (props, callback) {
      return this.$refs.form.validateField(props, callback)
    },
    submit () {
      let result = false
      this.$refs.form.validate((isSuccess, failObject) => {
        if (!isSuccess) {
          this.$nextTick(() => {
            this.$el.querySelector('.el-form-item.is-error').scrollIntoView({ block: 'center', behavior: 'smooth' })
          })
        }
        result = isSuccess
      })
      _.forEach(this.formErrors, (item, key) => {
        this.formErrors[key] = null
      })
      return result
    },
    onSubmit () {
      const result = this.submit()
      this.$nextTick(() => {
        this.$emit('submit', result)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.simple-form.el-form {
  .submit-btn {
    width: 100%;
    border-radius: 0;
    border-color: var(--custom-color);
    background-color: var(--custom-color);
    color: var(--custom-text-color, #000);
    font-size: 18px;
    font-weight: bold;

    &:focus, &:hover, &:active {
      border-color: var(--custom-color);
      color: var(--custom-text-color);
    }
  }

  ::v-deep {
    .el-form-item {
      margin-bottom: 30px;

      &.is-required:not(.is-no-asterisk) {
        .el-form-item__label {
          &:before {
            display: none;
          }

          &::after {
            content: '*';
            color: #4d4d4d;
          }
        }
      }

      &.is-error {
        .el-input__inner {
          border-color: #f56c6c;

          &:focus {
            border-color: #f56c6c;
          }
        }
      }
    }

    .el-form-item__label {
      font-size: 18px;
      font-weight: bold;
      padding-right: 20px;
      color: #2e2e2e;
    }

    .el-form-item__content {
      font-size: 16px;
    }

    .el-input {
      font-size: 16px;

      .el-input__inner {
        padding: 0 5px;
        border-radius: 0;
        border-color: #b2b2b2;
        color: #000;

        &:focus {
          border-color: #b2b2b2;
        }
      }

      &.password-input {
        .el-input__inner {
          padding-right: 50px;
        }

        .el-input__suffix {
          right: 20px;

          .el-icon-view {
            font-size: 26px;
          }
        }
      }
    }
  }
}
</style>
